import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-zf",
  "use": "icon-zf-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-zf\">\n<g id=\"icon-zf_Menu/zf\">\n<path id=\"icon-zf_Union\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1.5 2C1.5 1.72386 1.72386 1.5 2 1.5H5H5.5V2.5H5H2.5V5V5.5H1.5V5V2ZM2 14.5C1.72386 14.5 1.5 14.2761 1.5 14V11V10.5H2.5V11V13.5H5H5.5V14.5H5H2ZM14 14.5C14.2761 14.5 14.5 14.2761 14.5 14V11V10.5H13.5V11V13.5H11H10.5V14.5H11H14ZM14 1.5C14.2761 1.5 14.5 1.72386 14.5 2V5V5.5H13.5V5V2.5H11H10.5V1.5H11H14ZM8.5 7.49985H10.5V6.49985H9.04031L10.3904 4.81219L9.60957 4.1875L8 6.19946L6.39043 4.1875L5.60957 4.81219L6.95969 6.49985H5.5V7.49985H7.5V8.49985H5.5V9.49985H7.5V11.9998H8.5V9.49985H10.5V8.49985H8.5V7.49985Z\" fill=\"#282C33\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/zf.svg
// module id = mMsy
// module chunks = 140